import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { makeStyles } from '@mui/styles';
import React, { useEffect, useState } from "react";
import { useGameVideo } from '../../context/GameVideoContext';
import { userService } from '../../services';
import MediaCardList from './MediaCardList';
import RouteConstants from '../../common/RouteConstants';
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
    root: {
        [theme.breakpoints.up('sm')]: {
            padding: theme.spacing(1)
        },
    }
}));


export default function MediaCardContainer(props) {

    const navigate = useNavigate();
    const classes = useStyles();
    const [role, setRole] = useState();
    const { pendingVideo } = useGameVideo();


    useEffect(() => {
        setRole(userService.getUserRole());
    }, []);

    const handleViewProfileClick = (username) => {
        navigate(RouteConstants.COACHES_PROFILE_VIEW + "/" + username);
    }

    return (
        <div className={classes.root} >
            <Grid container >
                {pendingVideo && pendingVideo.length > 0 ? pendingVideo.map((item, index) => {
                    return <MediaCardList
                        key={index}
                        handleOpenDialog={props.handleOpenDialog}
                        data={item}
                        hideAction={props.hideAction}
                        role={role}
                        showMediaContent={props.showMediaContent}
                        mediaList={item?.profileVideos?.ProfileVideo}
                        handleViewProfileClick={handleViewProfileClick}
                    />
                }) :
                    <Grid size={12} style={{ margin: 24, display: "flex", justifyContent: "center", alignItems: "center", minHeight: '60vh' }}>
                        <Typography variant="body1" >No videos available for review.</Typography>
                    </Grid>}
            </Grid>
        </div>
    );
}
